module.exports = __webpack_public_path__ + "img/register-family-btn-en.e62d1193.png";